import React from 'react'
import { FaFacebookF, FaInstagram, FaEnvelope,FaBars,FaTimes} from "react-icons/fa";

const Footer = () => {
  return (
    <>   <footer className="w-full mt-12 p-6 bg-blue-950 text-white text-center transition duration-300 hover:bg-gray-800">
    <p className="text-sm">© 2025 The Quraniverse.ai. All Rights Reserved.</p>
    <div className="flex justify-center space-x-6 mt-4">
      <a href="https://www.facebook.com/people/Quraniverse-AI/pfbid05ThHeCx9GkQbDZXiqEei8Jc1g5Hsj3TdWVdY7ssVFX1vaZBKm7h3gqX4KKnXDPFrl/" target="_blank" rel="noopener noreferrer" className="text-white text-2xl hover:text-gray-400"><FaFacebookF /></a>
      <a href="https://www.instagram.com/quraniverse_ai/?igsh=MWo3c2trbXVodnhpbA%3D%3D#" target="_blank" rel="noopener noreferrer" className="text-white text-2xl hover:text-gray-400"><FaInstagram /></a>
      <a href="mailto:info@quraniverse.ai" className="text-white text-2xl hover:text-gray-400"><FaEnvelope /></a>
    </div>
  </footer> </>
  )
}

export default Footer